import React, { FC } from "react";
import { H3, Switch } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { SettingToggleContainer, ToggleContainer, VerticalContainer } from "./styled";

import { SettingToggleProps } from "./types";

export const ToggleBlock: FC<SettingToggleProps> = ({ label, checked, onChange, children }) => {
  const { t } = useTranslation("common");

  return (
    <SettingToggleContainer>
      <ToggleContainer>
        <H3>{label}</H3>
        <Switch title={t("toggleBlock.scale")} checked={checked} onChange={onChange} />
      </ToggleContainer>
      <VerticalContainer show={checked}>{children}</VerticalContainer>
    </SettingToggleContainer>
  );
};
